/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ShortNameField from '../Common/shortNameField';
import DetailHeader from './detailHeader';
import PlanTab from './detailPlanTab';
import { deploymentWorkPackagesSelector } from '../../selectors/workPackageSelector';
import {
  deleteDeployment,
  addResultToDeployment,
  removeResultFromDeployment,
  updateDeployment,
  restoreDeployment
} from '../../actions/deploymentActions';
import { allows } from '../../utils/authorization';

class DeploymentDetail extends React.Component {
  handleFieldChange = field => {
    this.props.updateDeployment(this.props.deployment.id, field);
  };

  render() {
    if (!this.props.isOpen) {
      return null;
    }
    const { deployment, stories, unshipped } = this.props;
    const allowEdit = allows('update', deployment);
    return (
      <div
        className="detail-modal workpackage-detail deployment-detail cadence-detail"
        tabIndex="-1"
        role="dialog"
      >
        <div className="detail-dialog" role="document">
          <div className="detail-content">
            <div className="modal-header detail-header">
              <DetailHeader
                deployment={deployment}
                stories={stories}
                onClose={this.props.onClose}
                handleUpdate={this.handleFieldChange}
                handleDelete={this.props.deleteDeployment}
                handleRestore={this.props.restoreDeployment}
              />
            </div>
            <div className="modal-body">
              <ShortNameField
                shortName={deployment.short_name}
                onNameChange={this.handleFieldChange}
                allowEdit={allowEdit}
              />
              <ul className="nav nav-tabs" role="tablist">
                <li role="presentation" className="active">
                  <a
                    href="#plan"
                    aria-controls="plan"
                    role="tab"
                    data-toggle="tab"
                  >
                    PLAN
                  </a>
                </li>
                <li role="presentation">
                  <a
                    href="#stories"
                    aria-controls="stories"
                    role="tab"
                    data-toggle="tab"
                  >
                    SCOPE
                  </a>
                </li>
                <li role="presentation">
                  <a
                    href="#metrics"
                    aria-controls="metrics"
                    role="tab"
                    data-toggle="tab"
                  >
                    TEAMS
                  </a>
                </li>
                <li role="presentation">
                  <a
                    href="#quality"
                    aria-controls="quality"
                    role="tab"
                    data-toggle="tab"
                  >
                    METRICS
                  </a>
                </li>
              </ul>
              <div className="tab-content">
                <div role="tabpanel" className="tab-pane active" id="plan">
                  <PlanTab
                    deployment={deployment}
                    stories={stories}
                    unshipped={unshipped}
                    add={this.props.addResultToDeployment}
                    remove={this.props.removeResultFromDeployment}
                  />
                </div>
                <div role="tabpanel" className="tab-pane" id="stories">
                  YET TO BE IMPLEMENTED
                </div>
                <div role="tabpanel" className="tab-pane" id="messages">
                  YET TO BE IMPLEMENTED
                </div>
                <div role="tabpanel" className="tab-pane" id="metrics">
                  YET TO BE IMPLEMENTED
                </div>
                <div role="tabpanel" className="tab-pane" id="dependencies">
                  YET TO BE IMPLEMENTED
                </div>
              </div>
            </div>
            <div className="modal-footer" />
          </div>
        </div>
      </div>
    );
  }
}

DeploymentDetail.propTypes = {
  id: PropTypes.number.isRequired,
  deployment: PropTypes.object,
  isOpen: PropTypes.bool,
  stories: PropTypes.array,
  unshipped: PropTypes.array,
  onClose: PropTypes.func,
  deleteDeployment: PropTypes.func,
  updateDeployment: PropTypes.func,
  addResultToDeployment: PropTypes.func,
  removeResultFromDeployment: PropTypes.func
};

const mapStateToProps = (state, ownProps) => {
  const deployment = state.deploymentReducer.deployments.find(
    f => f.id === ownProps.id
  );
  const allStories = state.workPackageReducer.stories;
  const deploymentWorkPackages = deploymentWorkPackagesSelector(state);

  return {
    deployment,
    stories: deploymentWorkPackages[ownProps.id] || [],
    unshipped: allStories.filter(story => !story.deployment)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateDeployment,
      addResultToDeployment,
      removeResultFromDeployment,
      deleteDeployment,
      restoreDeployment
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeploymentDetail);
